'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InviteAFriendHero = exports.InviteAFriendHeroUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _redux = require('redux');

var _bound = require('redux/saga/entities/bound');

var _page = require('redux/modules/page');

var _deep = require('helpers/deep');

var _inviteAFriendHero = require('./inviteAFriendHero.saga');

var _ClassAvailable = require('./ClassAvailable');

var _ClassUnavailable = require('./ClassUnavailable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InviteAFriendHeroUnwrapped = exports.InviteAFriendHeroUnwrapped = function (_Component) {
  (0, _inherits3.default)(InviteAFriendHeroUnwrapped, _Component);

  function InviteAFriendHeroUnwrapped() {
    (0, _classCallCheck3.default)(this, InviteAFriendHeroUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (InviteAFriendHeroUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(InviteAFriendHeroUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(InviteAFriendHeroUnwrapped, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.useReducedNavigation(false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          baseUrl = _props.baseUrl,
          ctaText = _props.ctaText,
          legal = _props.legal,
          _props$referral = _props.referral,
          data = _props$referral.data,
          loaded = _props$referral.loaded,
          title = _props.title,
          subtitle = _props.subtitle,
          unavailableSubtitle = _props.unavailableSubtitle,
          unavailableTitle = _props.unavailableTitle;


      var availability = (0, _deep.deepExtract)('schedule.availability.status', data, '');
      var heroContent = void 0;
      if (!loaded) {
        return false;
      } else if (availability === 'available') {
        heroContent = _react2.default.createElement(_ClassAvailable.ClassAvailable, {
          ctaText: ctaText,
          displayName: (0, _deep.deepExtract)('referrer.display_name', data),
          legal: legal,
          purchaseUrl: data.purchase_url,
          schedule: data.schedule,
          subtitle: subtitle,
          title: title
        });
      } else if (availability === 'unavailable') {
        heroContent = _react2.default.createElement(_ClassUnavailable.ClassUnavailable, {
          ctaText: ctaText,
          displayName: (0, _deep.deepExtract)('referrer.display_name', data, ''),
          legal: legal,
          purchaseUrl: data.purchase_url,
          subtitle: unavailableSubtitle,
          title: unavailableTitle,
          venueName: (0, _deep.deepExtract)('schedule.venue.name', data, '')
        });
      } else {
        heroContent = _react2.default.createElement(_ClassUnavailable.ClassUnavailable, {
          ctaText: 'See Plans',
          purchaseUrl: '/pricing',
          subtitle: 'Unfortunately, this promotion is no longer valid. Please double check with your friend for an up-to-date invite code.',
          title: 'Oh no! This promotion is no longer valid.'
        });
      }
      var imageUrl = (0, _deep.deepExtract)('schedule.venue.images.default', data);
      return _react2.default.createElement(
        'div',
        { className: 'invite-a-friend-hero bg--' + backgroundColor },
        _react2.default.createElement(_reactHelmet2.default, {
          title: 'ClassPass | You are Invited',
          meta: [{ property: 'og:url', content: baseUrl + 'invite' }, { property: 'og:image', content: imageUrl }, { name: 'robots', content: 'noindex' }]
        }),
        _react2.default.createElement(
          'div',
          { className: 'wrap wrap--narrow' },
          heroContent
        )
      );
    }
  }]);
  return InviteAFriendHeroUnwrapped;
}(_react.Component);

InviteAFriendHeroUnwrapped.propMapper = function (state, moduleDef) {
  return {
    backgroundColor: moduleDef.backgroundColor,
    baseUrl: state.request.baseUrl,
    ctaText: moduleDef.ctaText,
    legal: moduleDef.legal,
    referral: _bound.userActionCampaign.select(state, _bound.userActionCampaign.lastRequestedKey(state)),
    subtitle: moduleDef.subtitle,
    title: moduleDef.title,
    unavailableSubtitle: moduleDef.unavailableSubtitle,
    unavailableTitle: moduleDef.unavailableTitle
  };
};

InviteAFriendHeroUnwrapped.handlerMapper = function (dispatch) {
  return (0, _extends3.default)({
    dispatch: dispatch
  }, (0, _redux.bindActionCreators)({
    useReducedNavigation: _page.useReducedNavigation
  }, dispatch));
};

InviteAFriendHeroUnwrapped.propTypes = {
  backgroundColor: _propTypes2.default.oneOf(['light', 'white']),
  baseUrl: _propTypes2.default.string.isRequired,
  ctaText: _propTypes2.default.string.isRequired,
  legal: _propTypes2.default.string,
  referral: _propTypes2.default.object,
  subtitle: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired,
  unavailableSubtitle: _propTypes2.default.string,
  unavailableTitle: _propTypes2.default.string.isRequired,
  useReducedNavigation: _propTypes2.default.func.isRequired
};

InviteAFriendHeroUnwrapped.loadSaga = _inviteAFriendHero.loadSaga;

var InviteAFriendHero = exports.InviteAFriendHero = (0, _TrackDwell2.default)(InviteAFriendHeroUnwrapped);